import React, { Component } from "react";
import { Tabs } from "@adrianoferreira/wp-react-admin";
import {FieldGroupContext} from "../../../../../contexts/FieldGroupContext";
import TableSelection from "./../DisplayCustomTable/TableSelection";
import Filters from './../EditCustomTable/Filters'

export const DeleteCustomTable = (props) => {

	return(
		<div id="poststuff" className="display-data-box">
			<div id="slugdiv" className="postbox">
				<h2 className="hndle ui-sortable-handle"><span>Delete Custom Table</span></h2>
				<div className="inside" style={{display: 'block'}}>
					<div className="notice notice-warning inline" style={{display: 'block'}}><p><strong>This is a dangerous endpoint type!</strong> You must be sure of what you are doing. This endpoint will let you delete both single and a range of entries from any kind of database table, even default WordPress ones. So, pay attention specially to the Filters section and always make database backup.</p></div>
					<p>This action should be used whenever you want to delete entries from a custom database table.</p>

						{props.endpoint.createCustomTable && props.endpoint.createCustomTable.map(
							(el, index) =>

									<FieldGroupContext.Provider key={index} value={{
										action: 'deleteCustomTable',
										currentItem: index,
										endpointId: props.id,
										endpoint: props.endpoint
									}}>

									<Tabs tabs={[
										{
											name:    'tableSelection',
											title:   'Table Selection',
											content: <TableSelection group={'tableSelection'} key={index + '-tableSelection'}/>
										},
										{
											name:    'filters',
											title:   'Filters',
											content: <Filters group={'filters'} key={index + '-filters'}/>
										},
									]} />

								</FieldGroupContext.Provider>
						)}

				</div>
			</div>
		</div>
	)
};
